// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-sec {
  height: 100vh;
}
.layout-sec aside.ant-layout-sider {
  background: #fff;
  border-right: 1px solid #edf2f7;
}
.layout-sec aside.ant-layout-sider .img {
  padding: 20px 0px;
  text-align: center;
}
.layout-sec .ant-layout {
  height: 100vh;
  background: #ffffff;
  position: relative;
}
.layout-sec .main-content-wrapper {
  padding: 30px 20px 40px 20px;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.layout-sec .page-title,
.layout-sec .sec-title {
  font-weight: 600;
  font-size: 16px !important;
  margin-bottom: 20px;
}
.layout-sec .ant-menu-dark .ant-menu-item,
.layout-sec .ant-menu-dark .ant-menu-item-group-title,
.layout-sec .ant-menu-dark .ant-menu-item > a,
.layout-sec .ant-menu-dark .ant-menu-item > span > a {
  color: #77d0a7;
  border: 1px solid white;
}
.layout-sec .ant-menu-dark .ant-menu-item-selected > a,
.layout-sec .ant-menu-dark .ant-menu-item-selected > span > a,
.layout-sec .ant-menu-dark .ant-menu-item-selected > a:hover,
.layout-sec .ant-menu-dark .ant-menu-item-selected > span > a:hover,
.layout-sec .ant-menu-item a:hover {
  color: #ffffff !important;
}
@media (min-width: 481px) and (max-width: 767px) {
  .layout-sec .main-content-wrapper {
    padding: 40px 15px 0 15px;
    overflow-x: hidden;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .layout-sec .main-content-wrapper {
    padding: 40px 15px 0 15px;
    overflow-x: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/Layout.less"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAAA;EAII,gBAAA;EACA,+BAAA;AADJ;AAJA;EAOM,iBAAA;EACA,kBAAA;AAAN;AARA;EAYI,aAAA;EAEA,mBAAA;EACA,kBAAA;AAFJ;AAbA;EAkBI,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAFJ;AApBA;;EA0BI,gBAAA;EACA,0BAAA;EACA,mBAAA;AAFJ;AA1BA;;;;EAkCI,cAAA;EACA,uBAAA;AAFJ;AAjCA;;;;;EA0CI,yBAAA;AAFJ;AAqCA;EACE;IAEI,yBAAA;IACA,kBAAA;EApCJ;AACF;AA0CA;EACE;IAEI,yBAAA;IACA,kBAAA;EAzCJ;AACF","sourcesContent":["@import url(\"../assets/Styles/variables.less\");\n\n.layout-sec {\n  height: 100vh;\n\n  aside.ant-layout-sider {\n    background: #fff;\n    border-right: 1px solid #edf2f7;\n    .img {\n      padding: 20px 0px;\n      text-align: center;\n    }\n  }\n  .ant-layout {\n    height: 100vh;\n    // height: calc(100vh - 30px);\n    background: #ffffff;\n    position: relative;\n  }\n  .main-content-wrapper {\n    padding: 30px 20px 40px 20px;\n    height: 100vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .page-title,\n  .sec-title {\n    font-weight: 600;\n    font-size: 16px !important;\n    margin-bottom: 20px;\n  }\n  .ant-menu-dark .ant-menu-item,\n  .ant-menu-dark .ant-menu-item-group-title,\n  .ant-menu-dark .ant-menu-item > a,\n  .ant-menu-dark .ant-menu-item > span > a {\n    color: @light-primary-color;\n    border: 1px solid white;\n  }\n  .ant-menu-dark .ant-menu-item-selected > a,\n  .ant-menu-dark .ant-menu-item-selected > span > a,\n  .ant-menu-dark .ant-menu-item-selected > a:hover,\n  .ant-menu-dark .ant-menu-item-selected > span > a:hover,\n  .ant-menu-item a:hover {\n    color: @white-color !important;\n  }\n}\n\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .layout-sec {\n    .main-content-wrapper {\n      padding: 40px 15px 0 15px;\n      overflow-x: hidden;\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .layout-sec {\n    .main-content-wrapper {\n      padding: 40px 15px 0 15px;\n      overflow-x: hidden;\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
